import { Divider, Flex, Text, Tooltip } from '@chakra-ui/react';
import gql from 'graphql-tag';
import { useMemo } from 'react';
import { Column } from 'react-table';

import { useUserMeetingAccessViewQuery } from '@/@generated/codegen/API';
import { AppSpinner } from '@/ui/AppSpinner';
import Table from '@/ui/Table';

import { AdminUserListItemType } from '../AdminUserList/columns';

type Props = {
  row: AdminUserListItemType;
};

type Row = {
  meetingName: string;
};

gql`
  query UserMeetingAccessView(
    $where: UserWhereUniqueInput!
    $meetingPaginationArgs: PaginationArgs
  ) {
    getUser(where: $where) {
      ...UserFields
      client {
        ...ClientFields
      }
      explicitReadAccesses {
        edges {
          node {
            ...ExplicitUserAccessFields
          }
        }
      }
      meetings(paginationArgs: $meetingPaginationArgs) {
        edges {
          node {
            ...MeetingFields
            clients {
              edges {
                node {
                  ...ClientFields
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default function UserMeetingAccessView({ row }: Props) {
  const viewData = useUserMeetingAccessViewQuery({
    variables: {
      where: {
        id: row.id,
      },
      meetingPaginationArgs: {
        first: 100,
      },
    },
  });

  const columns: Column<Row>[] = [
    {
      Header: 'Meeting',
      accessor: (item: Row) => {
        return (
          <Tooltip label={item.meetingName} aria-label="meeting name">
            <Text noOfLines={1}>{item.meetingName}</Text>
          </Tooltip>
        );
      },
    },
  ];

  const data: Row[] = useMemo(() => {
    if (!viewData.data?.getUser) return [];
    const result: Row[] = viewData.data.getUser.meetings.edges
      .map((el) => el.node)
      .map((meeting) => {
        const row: Row = {
          meetingName: meeting.name,
        };
        return row;
      });
    return result;
  }, [viewData.data]);

  if (viewData.loading) {
    return <AppSpinner />;
  }

  return (
    <>
      <Text as="b">Meetings accesses:</Text>

      {data.length === 0 ? (
        <Flex justifyContent="center">
          <Text>User has access to no meetings.</Text>
        </Flex>
      ) : (
        <>
          <Divider marginY="10px" />
          <Table size="sm" columns={columns} data={data} />
        </>
      )}
    </>
  );
}
